import axios from "axios";
import { HttpClient } from "./http-client";
import responseInterceptors from "./response-interceptors";
import { requestInterceptors } from "./request-interceptors";

const httpClient = new HttpClient(
  axios,
  requestInterceptors,
  responseInterceptors
);
Object.freeze(httpClient);

export {
  httpClient,
};
